import { api } from './api'

function queryOf({ q, scope, occupation, company, school } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (scope && scope !== 'all') params.set('scope', scope)
  for (const value of occupation || []) params.append('occupation', value)
  for (const value of company || []) params.append('company', value)
  for (const value of school || []) params.append('school', value)
  const text = params.toString()
  return text ? `?${text}` : ''
}

export function listUsers(filters) {
  return api.get(`/users${queryOf(filters)}`)
}

export function getUser(id) {
  return api.get(`/users/${id}`).then((data) => data.user)
}

export function connectUser(id) {
  return api.post(`/users/${id}/connect`).then((data) => data.user)
}

export function acceptUser(id) {
  return api.post(`/users/${id}/accept`).then((data) => data.user)
}

export function denyUser(id) {
  return api.post(`/users/${id}/deny`).then((data) => data.user)
}

export function removeConnection(id) {
  return api.del(`/users/${id}/connection`).then((data) => data.user)
}

export function updateMyProfile(body) {
  return api.patch('/users/me', body).then((data) => data.user)
}
